import React, {useState, useEffect} from 'react';
import {Input, Modal} from "antd";
import Form, {FormInputComponent} from "../../components/form/Form";
import {useProject} from "../../providers/ClientProjectProvider";
import {useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import UserImageCircle from "../../components/UserImageCircle";
import SpinLoader from "../../components/SpinLoader";
import {useIsMutating} from "@tanstack/react-query";

const defaultModel = {
    email_subject: "Reminder about a role on Wripple",
    email_body: "Hello, I think this role might be a great fit for you. Check out the details using the link below."
}
const BulkCandidatesContactForm = ({...props}) => {

    const {project, isLoading, isDisabled, bulkActions, onClearBulkActions, onRunBulkActions} = useProject();
    const [searchParams, setSearchParams] = useSearchParams();
    const {positionId} = useParams();
    const {auth} = useAuth();

    const sendingEmails = useIsMutating({mutationKey: ['runBulkActions']})

    const [formModel, setFormModel] = useState({
        ...defaultModel
    });
    const onClose = async () => {
        let params = new URLSearchParams(searchParams);

        params.delete("send-candidate-message");
        await setSearchParams(params)
        return setFormModel({...defaultModel})
    }

    useEffect(() => {
        if (!bulkActions?.length && searchParams.has('send-candidate-message')) {
            onClose();
        }
    }, [bulkActions?.length]);

    if (!auth?.canManageClients()) {
        return null;
    }
    if (isLoading || !project) {
        return null
    }
    return (
        <Modal
            okText="Submit"
            title="Message to Talent"
            className="project-scope-modal"
            open={bulkActions.length && searchParams.has("send-candidate-message")}
            closeable={!isDisabled}
            centered
            maskClosable={!isDisabled}
            style={{top: 20}}
            destroyOnClose={true}
            okButtonProps={{disabled: isDisabled}}
            width={1000}
            zIndex={150}
            confirmLoading={isDisabled}
            onCancel={onClose}
            onOk={async () => {
                // wait for success response then fire onClose

                const response = await onRunBulkActions("message", positionId, {...formModel});

                if (response) {
                    await onClose();
                    return onClearBulkActions();
                }
            }}
        >
            <div className="project-scope-form relative">
                <SpinLoader isLoading={sendingEmails > 0}>

                    <div className="pb-4">
                        Compose your message below to send to the selected Candidates. Your message will be delivered
                        via
                        email to both you and the talent.
                    </div>
                    <Form
                        onSubmit={null}
                        model={formModel}
                        onChange={model => setFormModel({...formModel, ...model})}
                        minimal
                        submitButton={false}
                        background={"none"}
                        isDisabled={isDisabled}
                        fields={[]}
                    >

                        <div className="flex flex-col form-group">
                            <label className="col-form-label">
                                Selected Candidates
                            </label>

                            <div className="flex flex-row flex-wrap gap-x-4 gap-y-3.5">

                                {TB.map(bulkActions, talent => (
                                    <div key={`action-${talent.id}`} className="flex flex-row gap-2 items-center">
                                        <UserImageCircle size={40} user={talent}
                                                         className="mx-auto img-grayscale"/>

                                        <p className="text-base font-medium">
                                            {talent.fullName()}
                                        </p>
                                    </div>
                                ))}

                            </div>
                        </div>

                        <FormInputComponent
                            fieldName="email_subject"
                            value={formModel.email_subject || ''}
                            disabled={isDisabled}
                            maxLength={100}
                            required={true}
                            label="Subject"
                            placeholder=""
                            type="antd-input"
                        >

                            <Input autoFocus={true} defaultValue={formModel.email_subject}/>

                        </FormInputComponent>

                        <FormInputComponent
                            fieldName="email_body"
                            value={formModel.email_body || ''}
                            disabled={isDisabled}
                            rows={6}
                            label="Body"
                            maxLength={2000}
                            required={true}
                            placeholder=""
                            type="lexical-editor"
                            tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                        />

                    </Form>
                </SpinLoader>

            </div>

        </Modal>
    );
}

export default BulkCandidatesContactForm;